import React from "react";
import { List } from "../modules/Settings/Consultants";

export function ConsultantsListPage() {
  return <List />;
}
